
import { motion } from 'framer-motion';
import Gradient from '@/assets/medihub_gradient_mesh_blue.jpg';

const HeroSection = () => {
  return (
    <section className="pt-32 pb-20 px-4 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={Gradient}
          alt="MediHub gradient háttér"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 z-0"></div>
      </div>

      <div className="container mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto"
        >
          <span className="inline-block px-4 py-1.5 bg-white/20 text-white rounded-full shadow-md mb-6 font-medium backdrop-blur-sm">
            A MediHub Előnyei
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 hero-heading">
            Miért hasznos a <span className="text-medihub-accent">MediHub?</span>
          </h1>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            A MediHub segít naprakészen maradni és személyre szabott értesítéseket kapni az Önt érdeklő rendezvényekről
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mt-10"
          >
            <a
              href="/register/participant"
              className="px-8 py-4 bg-medihub-accent text-white rounded-full font-medium shadow-lg hover:shadow-xl hover:bg-medihub-accent/90 transition-all inline-flex items-center group"
            >
              Regisztráljon most
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
